import {
  PapiDaUserProfileModuleExhibitionistConfig,
  PapiPremiumFolderData,
} from '@wix/da-types-papi';

export interface Modules {
  [moduleId: number]: any;
}

export enum ModulePriv {
  EDIT = 'edit',
  DELETE = 'delete',
}

export enum ModuleType {
  ABOUT = 'about',
  BADGES_ACTIVITY = 'badges_activity',
  COMMENTS = 'comments',
  COMMISSIONS = 'commissions',
  COVER_DEVIATION = 'cover_deviation',
  CUSTOM = 'papi_custombox',
  DONATIONS = 'donations',
  DEVIOUSNESS = 'deviousness',
  DRAFTS = 'drafts',
  EXHIBITIONIST = 'exhibitionist',
  FEATURED_POST = 'featured_post',
  FEATURED_DEVIATION = 'featured_deviation',
  FEATURED_DEVIATIONS = 'featured',
  FEATURED_JOURNALS = 'featured_journals',
  FEATURED_POSTS = 'featured_posts',
  POSTS_FEED = 'posts_feed',
  FEED = 'feed',
  FEED_PINNED_DEVIATION = 'feed_pinned_deviation',
  FOLDERS = 'folders',
  FOLDER_DEVIATIONS = 'folder_deviations',
  GROUPS_ADMIN = 'group_list_admins',
  GROUPS_MEMBER = 'group_list_members',
  ACTIVE_MEMBERS = 'active_members',
  ADMINS = 'members',
  JOURNALS = 'journals',
  LATEST_DEVIATIONS = 'latest_deviation',
  MY_COMMENTS = 'my_comments',
  NEWEST_DEVIATIONS = 'newest',
  POLLS = 'polls',
  PREMIUM_CONTENT = 'premium_content',
  PREMIUM_FOLDERS = 'premium_folders',
  PRINTS = 'prints',
  STATS = 'userstats',
  STATUSES = 'statuses',
  VISITORS = 'visitors',
  WATCHERS = 'watchers',
  WATCHING = 'watching',
}

export type ExhibitionistModuleConfig = PapiDaUserProfileModuleExhibitionistConfig;
export type ExhibitionistModuleOptions = ExhibitionistModuleConfig['options'];
export type ExhibitionistModuleGalleryListItem = Unpacked<
  ExhibitionistModuleOptions['galleryList']
>;
export type ExhibitionistModuleCollectionListItem = Unpacked<
  ExhibitionistModuleOptions['collectionList']
>;
export type ExhibitionistModuleSourceTypeOptions = ExhibitionistModuleOptions['sourceTypes'];
export type ExhibitionistModuleFolderList = Pick<
  ExhibitionistModuleOptions,
  'galleryList' | 'collectionList'
>;
export type ExhibitionistPremiumFolderData = NonNullable<PapiPremiumFolderData>;

export enum ExhibitionistViewMode {
  TORPEDO = 'torpedo',
  SLIDESHOW = 'slideshow',
}

export enum ExhibitionistSlideFitMode {
  FIT = 'fit',
  COVER = 'cover',
}
